<template>
  <div id="body">
    <!--遮罩层-->
    <!-- <div v-if="this.dialogVisible" id="body1">
      <div><img alt="指引" class="body1-img" src="../assets/57@3x.png"></div>
      <div id="font1" class="body1-font">点击右上角</div>
      <div id="font2" class="body1-font">用浏览器打开并下载</div>
    </div> -->

    <div v-if="type === 2">
      <div id="head">
        <div class="title">
          <div id="title-img"><img alt="" class="img" src="../assets/tpWarn@3x.png"></div>
          <div id="title-font">关注公众号</div>
        </div>
        <div id="title2">
          线上激活电子保修卡
        </div>
        <div class="code">
          <img alt="二维码" class="code-img" src="../assets/code.jpg">
        </div>
        <div class="title4">
          长按识别图中二维码
        </div>
      </div>
    </div>
    <div v-if="type === 1">
      <div style="color: #2b3335">
        <div id="head2">
          <!-- <div class="title" style="display: flex;justify-content: center;align-items: center;" v-show="isResponse">
            <div class="title-img1" v-if="!notInStorage_code"><img alt="" class="img" :src="appLogo ? appLogo : '/static/AppIcon.png'"></div>
            <div class="title-font2">
              <div>
                欢迎使用{{AppName}}
              </div>
              <div>
                打开小程序查看车辆状态
              </div>
            </div>
          </div> -->
          <div v-if="notInStorage_code">产品「SN：{{notInStorage_code}}」未入库，请联系技术支持</div>
          <div v-if="dialogVisible && Boolean(AppletPrimitiveId)" class="main_block"> 
            <div class="plate_block">
              <div v-if="infoObj && infoObj.entName" class="ent_info">
                <img :src="infoObj.entLogo" v-if="infoObj.entLogo" :class="!infoObj.groupName ? 'mini_logo': ''"/>
                <div class="ent_info_right">
                  <p>{{infoObj.entName}}</p>
                  <p v-if="infoObj.groupName">{{infoObj.groupName}}</p>
                </div>
              </div>
              <div>设备{{parentNumber}}「SN：{{snCode}}」</div>
              <template v-if="plate">
                <div v-if="snCode && snCode.slice(-6) == plate">临时绑定车牌</div>
                <div v-else>已绑定车牌</div>
                <div class="plate_text">{{plate}}</div>
              </template>
            </div>
            <!-- <h2>请选择您的身份</h2>
            <p>可以多选</p>
            <div class="id_block">
              <div class="id_item">驾驶员</div>
              <div class="id_item">安装师傅</div>
              <div class="id_item">维保工程师</div>
              <div class="id_item">个人车主</div>
              <div class="id_item">车队管理员</div>
            </div> -->
            <!-- env-version="trial" -->
              <!-- :path="sn?'pages/tabBar/home.html?sn='+sn:'pages/tabBar/home.html'" -->
            <wx-open-launch-weapp
              id="launch-btn"
              :username="AppletPrimitiveId"
              :path="pageUrl"
              @launch="handleLaunchFn"
              @error="handleErrorFn"
              style="width: 250px;"
            >
              <script type="text/wxtag-template">
                <style>
                  .open{
                    padding: 15px;
                    text-align: center;
                    margin-top: 100px;
                  }
                  .btn{
                    background-color: #19be6b;
                    color: white;
                    padding: 15px 30px;
                    border: none;
                    border-radius: 5px;
                    font-size: 20px;
                  }
                </style>
                <div class="open">
                  <button class="btn">打开小程序</button>
                </div>
              </script>
            </wx-open-launch-weapp>
            <!-- <a class="product_link" v-if="parentNumber" :href="'https://tapi.e5ex.com/product?p='+parentNumber"> -->
            <a class="product_link" v-if="parentNumber" :href="'https://tapi.e5ex.com/product?p='+(parentNumber.includes('R9') ? 'R90' : parentNumber)">
              查看{{parentNumber}}产品介绍
            </a>
          </div>
           <div v-if="!dialogVisible" class="code">
            <!-- <img :src="this.downUrl" alt="二维码" class="code-img"> -->
            <div style="font-size: 18px;color: rgba(0, 0, 0, 1);padding-top: 15px;">
              请使用微信打开
            </div>
          </div>
          <!-- <div v-else class="code">
            <img :src="this.downUrl" alt="二维码" class="code-img">
            <div style="font-size: 18px;color: rgba(0, 0, 0, 1);padding-top: 15px;">
              请保存二维码，在微信中识别
            </div>
          </div> -->
        </div>
      </div>
      <!-- <div v-if="AppName == 'TORO'" class="button" style="border-top:1px solid #767474" v-on:click="gotoType()">
        电子保修卡
        <div class="symbol">></div>
      </div> -->
    </div>
  </div>
</template>
<script>
import {getSign,imeiSn} from '../api/api';
export default {
  data() {
    return {
      infoObj: {},
      pageUrl: '',
      hrefUrl: '',
      appLogo: '',
      dialogVisible: true,
      type: 1,
      explainUrl: '',
      downUrl: 'https://cv.e5ex.cn/app/qrCode/iphone.png',
      sn: "",
      AppletPrimitiveId: "",
      notInStorage_code: "",
      AppName: "",
      snCode: "",
      plate: "",
      parentNumber: "",
      isResponse: false
    };
  },
  created() {
    this.checkViewport();
  },
  mounted(){
    this.ToMiniapp();
  },
  methods: {
    handleLaunchFn(e) {
      console.log('success', e.detail);
        // window.open("https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzkzMTE4MDY5MA==#wechat_redirect");
    },
    handleErrorFn(e){
      console.log('fail', e.detail);
    },
    ToMiniapp() {
      // window.location.href.split('#')[0]
      // window.location.href.split('R')[1].substr(3,window.location.href.split('/#/')[1].length)
      getSign(window.location.href.split('/#/')[0],window.location.href.split('/#/')[1]).then(({code, msg, data}) => {
        if (code === 0) {
          this.infoObj = data;
          this.AppletPrimitiveId = data.AppletPrimitiveId;
          this.AppName = data.AppName;
          this.pageUrl = data.page;
          this.isResponse = true;
          this.appLogo = data.logo;
          document.title = this.AppName;
          this.plate = data.plate;
          this.parentNumber = data.parentNumber;
          this.snCode = data.Sn;
          wx.config({
            debug: false,
            appId: "wxa897b31443ea9c96",
            signature: data.signature,
            nonceStr: data.nonceStr,
            timestamp: data.timestamp,
            jsApiList: [],
            openTagList: ["wx-open-launch-weapp"]
          });
          wx.ready(() => {
            console.log('wx ready')
          });
          wx.error(function (res) {
            console.log("error",res)
          });
          this.notInStorage_code = '';
        } else if (code == -2) {
          // 未入库的设备号
          // this.$message.error(`产品「SN：${data}」未入库，请联系技术支持`);
          this.notInStorage_code = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 查看当前配置
    checkViewport() {
      //判断设备 /R862177043673170
      let path = this.$router.currentRoute.path;
      this.sn = 'https://e5ex.com/'+window.location.href.split('/#/')[1];
      //下载APP
      if (path.substr(1, 1) === 'R' || path.substr(1, 4) === 'show') {
        this.type = 1;
      }
      //关注公众号
      else if (path.substr(1, 1) === 'A') {
        this.type = 2;
        this.sn = "";
      }
      let u = navigator.userAgent;
      let platform = navigator.platform;
      if (u.toLowerCase().match(/MicroMessenger/i) == "micromessenger") {
        this.dialogVisible = true;
      }else{
        this.dialogVisible = false;
      }
      // 判断是否是微信内核
      // if (/MicroMessenger/i.test(u.toLowerCase())) {
      //   if (u.indexOf('iPhone') > -1) {
      //     //苹果微信浏览器
      //     this.hrefUrl = 'https://apps.apple.com/cn/app/toro%E8%83%8E%E5%8E%8B/id1521589697';
      //     this.downUrl = 'https://cv.e5ex.cn/app/qrCode/iphone1.png';
      //   } else if (u.indexOf('Android') > -1) {
      //     if (this.type === 1) {
      //       //安卓微信浏览器
      //       // this.dialogVisible = true;
      //     }
      //     this.hrefUrl = 'https://cv.e5ex.cn/app/Tp.apk';
      //     this.downUrl = 'https://cv.e5ex.cn/app/qrCode/Android1.png';
      //   } else if (/Win\d{2}|Windows/.test(platform) || !!u.match(/\(Macintosh; Intel /)) {
      //     //电脑微信浏览器
      //     this.hrefUrl = 'https://cv.e5ex.cn/app/Tp.apk';
      //     this.downUrl = 'https://cv.e5ex.cn/app/qrCode/Android1.png';
      //   }
      // } else if (u.indexOf('Android') > -1 || u.indexOf('iPhone') > -1) {
      //   // 其他浏览器内核   判断是否是安卓还是IOS
      //   if (u.indexOf('iPhone') > -1) {
      //     //iPhone其他浏览器
      //     this.hrefUrl = 'https://apps.apple.com/cn/app/toro%E8%83%8E%E5%8E%8B/id1521589697';
      //     this.downUrl = 'https://cv.e5ex.cn/app/qrCode/iphone1.png';
      //   } else if (u.indexOf('Android') > -1) {
      //     //Android其他浏览器
      //     this.hrefUrl = 'https://cv.e5ex.cn/app/Tp.apk';
      //     this.downUrl = 'https://cv.e5ex.cn/app/qrCode/Android1.png';
      //     window.location.href = 'https://cv.e5ex.cn/app/Tp.apk'
      //   }
      // } else if (/Win\d{2}|Windows/.test(platform) || !!u.match(/\(Macintosh; Intel /)) {
      //   //电脑端其他浏览器
      //   this.hrefUrl = 'https://cv.e5ex.cn/app/Tp.apk';
      //   this.downUrl = 'https://cv.e5ex.cn/app/qrCode/Android1.png';
      // }

      let query = path.substr(2, 3);
      // if(path.indexOf("/R") !== -1){
      //   imeiSn(path.replace('/R','')).then(res => {
      //     if((res.data?true:false) && (res.data.indexOf("R3") !== -1)){
      //       this.explainUrl = "https://portal.e5ex.cn/manual/r3";
      //     }else if(query === "R64" || query === 'R14') {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/r2";
      //     } else if (query.substr(0, 2) === "Rk") {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/k1";
      //     } else if (query.substr(0, 2) === "RZ") {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/t1";
      //     } else {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/r1";
      //     }
      //   });
      // }else if(path.indexOf("/show") !== -1){
      //   imeiSn(path.replace('/show','')).then(res => {
      //     if((res.data?true:false) && (res.data.indexOf("R3") !== -1)){
      //       this.explainUrl = "https://portal.e5ex.cn/manual/r3";
      //     }else if(query === "R64" || query === 'R14') {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/r2";
      //     } else if (query.substr(0, 2) === "Rk") {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/k1";
      //     } else if (query.substr(0, 2) === "RZ") {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/t1";
      //     } else {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/r1";
      //     }
      //   });
      // }else{
      //   if(query === "R64" || query === 'R14') {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/r2";
      //     } else if (query.substr(0, 2) === "Rk") {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/k1";
      //     } else if (query.substr(0, 2) === "RZ") {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/t1";
      //     } else {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/r1";
      //     }
      // }
      
    },
    gotoType() {
      this.type = 2;
    }
  }
}
</script>
<style scoped>
.ent_info{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}
.ent_info>img{
  height: 45px;
  width: 45px;
  border-radius: 7.5px;
}
.ent_info>img.mini_logo{
  height: 25px;
  width: 25px;
}
.ent_info_right{
  margin-left: 10px;
  font-size: 16px;
  line-height: 25px;
}
.plate_block{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 50px;
}
.plate_text{
  padding: 5px 8px;
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin: 10px 0 0;
  width: auto;
  background-color: #fec922;
  text-align: center;
  border: 2px solid #000;
  border-radius: 8px;
}
.main_block{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.btn:active{
  background-color: rgba(25, 190, 107, 0.8);
}
.body1-img {
  position: absolute;
  height: 50px;
  width: 90px;
  right: 20px;
  top: 10px;
}
.product_link{
  display: block;
  width: 160px;
  padding: 10px;
  border-radius: 5px;
  color: #4d70ff;
  box-shadow: 0px -2px 10px 2px #CCCCCC;
  margin-top: 40px;
  text-align: center;
}

.body1-font {
  position: absolute;
  color: rgba(255, 255, 255, 0.87);
  font-size: 20px;
}

#font1 {
  top: 45px;
  right: 120px;
}

#font2 {
  top: 80px;
  right: 40px;
}

#body {
  height: 100%;
  width: 100%;
  position: absolute;
  background: url("../assets/back.jpg");
  background-size: 80%;
}

#body1 {
  position: fixed;
  background: rgba(0, 0, 0, 0.67);
  z-index: 1020000000000000;
  height: 100%;
  width: 100%;
}

#head {
  height: 320px;
  width: 200px;
  margin: 80px auto 40px;
}

#head2 {
  min-height: 280px;
  /* width: 250px; */
  padding: 0 20px;
  margin: 80px auto 0;
  position: relative;
}

.title {
  width: calc(100% + 2px);
  height: 40px;
  display: flex;
  align-items: center;
}

#title2 {
  width: 100%;
  height: 20px;
  margin: 15px 10px;
  font-size: 20px;
  color: #878787;
}

.title3 {
  width: 100%;
  height: 20px;
  margin: 15px 70px;
  font-size: 16px;
}

.title4 {
  width: 100%;
  height: 20px;
  margin: 15px 28px;
  font-size: 16px;
}

.img {
  height: 45px;
  width: 45px;
}

#title-img {
  float: left;
}

.title-img1 {
  float: left;
  display: flex;
  align-content: center;
}
.title-img1 > img{
  border-radius: 7.5px;
}

.title-font2 {
  font-family: Source Han Sans CN, sans-serif;
  float: left;
  font-size: 16px;
  line-height: 25px;
  margin-left: 8px;
  color: rgba(0, 0, 0, 1);
}

#title-font {
  font-family: Source Han Sans CN, sans-serif;
  float: right;
  font-weight: 1000;
  font-size: 30px;
  line-height: 40px;
}

.code {
  height: 180px;
  width: 100%;
  text-align: center;
  margin: 30px 0;
}

.code-img {
  height: 180px;
  width: 180px;
}

.button {
  height: 42px;
  width: 85%;
  margin: 0 auto auto;
  font-size: 20px;
  line-height: 40px;
  color: #808080;
}

.symbol {
  float: right;
  margin: auto 0;
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/download.vue